import axios from 'axios';
import { Capacitor } from '@capacitor/core';

const PROD_SITE_URL = 'https://freematch.uk';
const PROD_API_ORIGIN = 'https://api.freematch.uk';
const PROD_API_BASE_URL = `${PROD_API_ORIGIN}/api`;
const LOCAL_API_ORIGIN = 'http://localhost:4000';
const LOCAL_API_BASE_URL = `${LOCAL_API_ORIGIN}/api`;

export const SITE_URL =
  process.env.REACT_APP_SITE_URL || PROD_SITE_URL;
// 네이티브 앱(Capacitor 번들)은 hostname이 'localhost'이므로 반드시 프로덕션 API 사용
export const API_ORIGIN =
  process.env.REACT_APP_SERVER_URL ||
  (Capacitor.isNativePlatform()
    ? PROD_API_ORIGIN
    : window.location.hostname === 'localhost' ? LOCAL_API_ORIGIN : PROD_API_ORIGIN);
export const API_BASE_URL =
  process.env.REACT_APP_API_BASE_URL || `${API_ORIGIN}/api`;

export const SITE_URL_LOCAL = LOCAL_API_ORIGIN;

export const getAuthProviderUrl = (provider: string) =>
  `${API_BASE_URL}/auth/${provider}`;

const ensureLeadingSlash = (value: string) =>
  value.startsWith('/') ? value : `/${value}`;

export const apiOriginUrl = (path = '') =>
  path ? `${API_ORIGIN}${ensureLeadingSlash(path)}` : API_ORIGIN;

export const apiBaseUrl = (path = '') =>
  path ? `${API_BASE_URL}${ensureLeadingSlash(path)}` : API_BASE_URL;

const rewriteBackendUrl = (url: string) => {
  if (!url) {
    return url;
  }

  if (url.startsWith(PROD_API_BASE_URL) && API_BASE_URL !== PROD_API_BASE_URL) {
    return `${API_BASE_URL}${url.slice(PROD_API_BASE_URL.length)}`;
  }

  if (url.startsWith(PROD_API_ORIGIN) && API_ORIGIN !== PROD_API_ORIGIN) {
    return `${API_ORIGIN}${url.slice(PROD_API_ORIGIN.length)}`;
  }

  if (url.startsWith(LOCAL_API_BASE_URL) && API_BASE_URL !== LOCAL_API_BASE_URL) {
    return `${API_BASE_URL}${url.slice(LOCAL_API_BASE_URL.length)}`;
  }

  if (url.startsWith(LOCAL_API_ORIGIN) && API_ORIGIN !== LOCAL_API_ORIGIN) {
    return `${API_ORIGIN}${url.slice(LOCAL_API_ORIGIN.length)}`;
  }

  return url;
};

let installed = false;

export const installRuntimeNetworkOverrides = () => {
  if (installed || typeof window === 'undefined') {
    return;
  }

  installed = true;

  const originalFetch = window.fetch.bind(window);
  window.fetch = (input: RequestInfo | URL, init?: RequestInit) => {
    if (typeof input === 'string') {
      return originalFetch(rewriteBackendUrl(input), init);
    }

    if (input instanceof URL) {
      return originalFetch(new URL(rewriteBackendUrl(input.toString())), init);
    }

    const rewrittenUrl = rewriteBackendUrl(input.url);
    if (rewrittenUrl === input.url) {
      return originalFetch(input, init);
    }

    return originalFetch(new Request(rewrittenUrl, input), init);
  };

  axios.interceptors.request.use((config) => {
    if (config.baseURL) {
      config.baseURL = rewriteBackendUrl(config.baseURL);
    }
    if (typeof config.url === 'string') {
      config.url = rewriteBackendUrl(config.url);
    }
    return config;
  });
};
